import { defineStore } from "pinia";
import {reactive} from "vue";


export const useInsuranceCancelationStore = defineStore("insuranceCancelation", () => {

    const listPage = reactive({ number : "", status : "all", personName: "", statusManagement :"all"})
    return {listPage};
});